import { render, staticRenderFns } from "./ParcelamentoCreate.vue?vue&type=template&id=05b2e0c0&"
import script from "./ParcelamentoCreate.vue?vue&type=script&lang=js&"
export * from "./ParcelamentoCreate.vue?vue&type=script&lang=js&"
import style0 from "./ParcelamentoCreate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports